import React from "react";
import { Link } from "react-router-dom";

import { ArrowRight, Upload, PenTool, Share2 } from "lucide-react";

import { Button } from "../components/ui/button";

import { PageLayout } from "../components/PageLayout";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "../components/ui/carousel";

const HomePage: React.FC = () => (
  <PageLayout>
    <div className="container max-w-5xl space-y-24 py-12">
      {/* Hero Section */}
      <section className="text-center space-y-6">
        <h1 className="text-5xl md:text-7xl font-bold tracking-tight animate-in slide-in-from-bottom-4">
          Diagramming made simple
        </h1>
        <p className="text-xl text-muted-foreground max-w-2xl mx-auto animate-in fade-in duration-700">
          Snap a photo and instantly turn it into an editable diagram.
        </p>

        <img
          className="mx-auto w-12 sm:w-1/3 animate-in fade-in duration-700"
          style={{
            minWidth: 250,
            maxWidth: "100%",
          }}
          alt="SnapNote Logo"
          src="./images/camera.png"
        />

        <div className="flex flex-col sm:flex-row gap-4 justify-center animate-in slide-in-from-top-2">
          <Link to="/capture">
            <Button size="lg" className="gap-2">
              Get Started
              <ArrowRight className="h-4 w-4" />
            </Button>
          </Link>
          <Link to="/templates">
            <Button size="lg" variant="outline">
              Browse Templates
            </Button>
          </Link>
        </div>
      </section>

      {/* Features Section */}
      <section className="grid md:grid-cols-3 gap-8 animate-in fade-in zoom-in-90">
        <div className="flex flex-col items-center gap-4 p-6 rounded-lg bg-muted/30">
          <Upload className="h-12 w-12 text-primary" />
          <h3 className="text-xl font-bold">Capture</h3>
          <p className="text-sm text-muted-foreground text-center">
            Use your camera to snap diagrams and whiteboards.
          </p>
        </div>
        <div className="flex flex-col items-center gap-4 p-6 rounded-lg bg-muted/30">
          <PenTool className="h-12 w-12 text-primary" />
          <h3 className="text-xl font-bold">Edit</h3>
          <p className="text-sm text-muted-foreground text-center">
            Refine shapes, add text and customize with ease.
          </p>
        </div>
        <div className="flex flex-col items-center gap-4 p-6 rounded-lg bg-muted/30">
          <Share2 className="h-12 w-12 text-primary" />
          <h3 className="text-xl font-bold">Share</h3>
          <p className="text-sm text-muted-foreground text-center">
            Export or share your diagrams with your team.
          </p>
        </div>
      </section>

      {/* Carousel Section */}
      <section className="relative">
        <Carousel className="rounded-lg overflow-hidden w-64 mx-auto">
          <CarouselContent>
            <CarouselItem>
              <img
                src="/screenshots/virtual-whiteboard.png"
                alt="Whiteboard"
                className="rounded-lg w-full"
              />
            </CarouselItem>
            <CarouselItem>
              <img
                src="/screenshots/shapes.png"
                alt="Shapes"
                className="rounded-lg w-full"
              />
            </CarouselItem>
            <CarouselItem>
              <img
                src="/screenshots/export.png"
                alt="Export"
                className="rounded-lg w-full"
              />
            </CarouselItem>
          </CarouselContent>
          <CarouselPrevious />
          <CarouselNext />
        </Carousel>
      </section>
    </div>
  </PageLayout>
);

export default HomePage;
